import { ShowSnackbar } from '../../shared/shared.actions'
import {
  FetchMobileTasksSuccess,
  FetchMobileTasksFailure,
  FetchMobileTasksRequest,
  AutoAssignTasksSuccess,
  AutoAssignTasksRequest,
  AutoAssignTasksFailure,
} from './mobile-tasks.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as MobileTasksTypes from './mobile-tasks.types'

import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { MobileTasksService } from './mobile-tasks.service'

@Injectable()
export class MobileTasksEffects {
  constructor(
    private actions: Actions,
    private mobileTasksService: MobileTasksService,
    private router: Router,
  ) {}

  FetchMobileTasks$ = createEffect(() =>
    this.actions.pipe(
      ofType(MobileTasksTypes.FETCH_MOBILE_TASKS_REQUEST),
      switchMap((action: FetchMobileTasksRequest) => {
        return this.mobileTasksService.fetchMobileTasks(action.payload).pipe(
          map((result) => {
            return new FetchMobileTasksSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            console.log(err)
            return of(new FetchMobileTasksFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  AutoAssignTasks$ = createEffect(() =>
    this.actions.pipe(
      ofType(MobileTasksTypes.AUTOASSIGN_TASKS_REQUEST),
      switchMap((action: AutoAssignTasksRequest) => {
        return this.mobileTasksService.autoAssignTasks(action.userId).pipe(
          map((result) => {
            return new AutoAssignTasksSuccess(result.data)
          }),
          catchError((err, caught) => {
            console.log(err)
            return of(new AutoAssignTasksFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
